import type { NormalizedDevice } from './types';

/**
 * Converts a NormalizedDevice to a MediaDeviceInfo-compatible object.
 * Used by RecordingContext to maintain backward compatibility with
 * UI components that expect MediaDeviceInfo (mic dropdowns, etc.).
 */
export function normalizedToMediaDeviceInfo(device: NormalizedDevice): MediaDeviceInfo {
  return {
    deviceId: device.browserDeviceId,
    groupId: device.groupId ?? '',
    kind: 'audioinput' as MediaDeviceKind,
    label: device.displayLabel,
    toJSON() {
      return {
        deviceId: this.deviceId,
        groupId: this.groupId,
        kind: this.kind,
        label: this.label,
      };
    },
  };
}
